// src/constants/dataTypes.js

export const ctModes = {
  Undefined: 'Undefined' ,
  T1: 'T1',
  S1: 'S1',
  C1: 'C1',
  C1T1: 'C1 & T1'
}



// export const fwdDataTypes = [
//   { value: 'DMReadout', label: 'Meter readout' },
//   { value: 'DMScan', label: 'Meter scan' },
//   { value: 'QnodeReadout', label: 'Network readout' },
//   { value: 'QnodeScan', label: 'Network scan' },
//   { value: 'CustomerReport', label: 'Report' }
// ];
